import { render, staticRenderFns } from "./DrawerUserSettingsSection.vue?vue&type=template&id=66f13123&"
import script from "./DrawerUserSettingsSection.vue?vue&type=script&lang=js&"
export * from "./DrawerUserSettingsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports